import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EnquiryHeaderItem } from '../../models/data/enquiry.model';

@Component({
  selector: 'app-modal-price-options-cr',
  templateUrl: './modal-price-options-cr.component.html',
  styleUrls: ['./modal-price-options-cr.component.scss']
})
export class ModalPriceOptionsCrComponent implements OnInit, OnChanges {

  @Input() item?: EnquiryHeaderItem;
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() initialFullCost: number | null = null;
  @Input() initialAlloySurchargeValue: number | null = null;

  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Output() onSave: EventEmitter<{ fullCost: number; alloySurchargeValue: number | null }> = new EventEmitter();

  fullCost: number | null = null;
  alloySurchargeValue: number | null = null;

  ngOnInit(): void {
    this.applyInitialValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["initialFullCost"] || changes["initialAlloySurchargeValue"] || changes["item"]) {
      this.applyInitialValues();
    }
  }

  get showAlloySurchargeInput(): boolean {
    return this.item?.alloySurcharge === false;
  }

  get fullCostUom(): string {
    return this.item?.costsUom ?? '';
  }

  get canSave(): boolean {
    const hasFullCost = this.fullCost !== null && this.fullCost > 0;
    const hasAlloySurcharge = !this.showAlloySurchargeInput || (this.alloySurchargeValue !== null && this.alloySurchargeValue > 0);
    return hasFullCost && hasAlloySurcharge;
  }

  onFullCostInput(value: any) {
    this.fullCost = this.toNumberOrNull(value);
  }

  onAlloySurchargeInput(value: any) {
    this.alloySurchargeValue = this.toNumberOrNull(value);
  }

  save() {
    if (!this.canSave) {
      return;
    }

    this.onSave.emit({
      fullCost: this.fullCost!,
      alloySurchargeValue: this.showAlloySurchargeInput ? this.alloySurchargeValue! : null
    });
  }

  cancel() {
    this.onCancel.emit();
  }

  private applyInitialValues() {
    this.fullCost = this.initialFullCost ?? null;
    this.alloySurchargeValue = this.showAlloySurchargeInput ? (this.initialAlloySurchargeValue ?? null) : null;
  }

  private toNumberOrNull(value: any): number | null {
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }
}
